import {BookDetailReservationGroupModel} from './BookDetailReservationGroup.model';

export class MenuItemBookDetailModel {
  id: number;
  menu_item_id: number;
  menu_item_book_id: number;
  start_time: Date | string;
  end_time: Date | string;
  name: string;
  bookable: boolean;
  interval: number;
  price: number;
  activate_offer: boolean;
  offer_price: number;
  offer_title: string;
  currency_code: string;
  view_count: number;
  limit: number;
  child_price: number;
  auto_approve: boolean;
  book_detail_res_group: BookDetailReservationGroupModel[];

  constructor(id = 0,
              menu_item_id = 0,
              menu_item_book_id = 0,
              start_time = new Date(),
              end_time = new Date(),
              name = '',
              bookable = false,
              interval = 10,
              price = 0,
              activate_offer = false,
              offer_price = 0,
              offer_title = '',
              currency_code = '',
              view_count = 0,
              limit = 0,
              child_price = 0,
              auto_approve = false,
              book_detail_res_group = []) {
    this.id = id;
    this.menu_item_id = menu_item_id;
    this.menu_item_book_id = menu_item_book_id;
    this.start_time = start_time;
    this.end_time = end_time;
    this.name = name;
    this.bookable = bookable;
    this.interval = interval;
    this.price = price;
    this.activate_offer = activate_offer;
    this.offer_price = offer_price;
    this.offer_title = offer_title;
    this.currency_code = currency_code;
    this.view_count = view_count;
    this.limit = limit;
    this.child_price = child_price;
    this.auto_approve = auto_approve;
    this.book_detail_res_group = book_detail_res_group;
  }
}
